import type { MessageDescriptor, IntlShape } from 'react-intl-next';

export const renderOverrideLabel = (
	formatMessage: IntlShape['formatMessage'],
	descriptor?: MessageDescriptor,
) => {
	if (descriptor) return formatMessage(descriptor);
};
